/* eslint-disable vue/multi-word-component-names */

<template>
  <footer class="footer">
    <div class="footer__copy">
      &copy; mjccreative {{ new Date().getFullYear() }} | all rights reserved
    </div>
    <div class="footer__top-link" @click="backToTop">
      <img
        src="../assets/site-icons/backtotop-icon.svg"
        alt="red arrow pointing up"
        class="footer__top-img"
        aria-role="top"
      />
    </div>
  </footer>
</template>

<script type="text/javascript">
export default {
  methods: {
    backToTop: function() {
      document.getElementById("top").scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables";

.footer {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  align-items: center;
  margin-top: 30px;
  border-top: 1px solid var(--light-grey);
  &__copy {
    font-size: 11px;
    color: var(--black);
  }
  &__top-link {
    cursor: pointer;
  }
  &__top-img {
    width: 50px;
    height: 25px;
  }
}
</style>
